<template>
  <div v-loading="loading">
    <FormBox :title="$t('message.DataRegistration.formData.payment_info')">
      <template slot="right">
        <el-button
          style="max-width: 270px"
          type="primary"
          plain
          @click="$router.push('/paymentRecord')"
          >{{ $t("message.DataRegistration.Taxi.showRecord") }}</el-button
        >
      </template>
      <el-form
        ref="ruleForm"
        :model="form"
        class="form_type1_box"
        hide-required-asterisk
        label-position="top"
      >
        <el-row :gutter="86">
          <!-- 缴付项目描述 -->
          <el-col :xs="24" :sm="12">
            <el-form-item
              :label="$t('message.DataRegistration.Taxi.payment_describe')"
            >
              <el-input
                v-if="$i18n.locale == 'PT'"
                v-model="form.cheque.namePt"
                disabled
              ></el-input>
              <el-input v-else v-model="form.cheque.nameCn" disabled></el-input>
            </el-form-item>
          </el-col>
          <!-- 繳付狀態 -->
          <el-col :xs="24" :sm="12">
            <el-form-item
              :label="$t('message.DataRegistration.Taxi.payment_status')"
            >
              <el-input v-model="approved" disabled></el-input>
            </el-form-item>
          </el-col>
          <!-- 年度費用 -->
          <el-col :xs="24" :sm="12">
            <el-form-item :label="$t('message.DataRegistration.Taxi.amount')">
              <el-input v-model="form.cheque.amount" disabled></el-input>
            </el-form-item>
          </el-col>
          <!-- 稅金 -->
          <el-col :xs="24" :sm="12">
            <el-form-item
              :label="$t('message.DataRegistration.Taxi.taxAmount')"
            >
              <el-input v-model="form.cheque.taxAmount" disabled></el-input>
            </el-form-item>
          </el-col>
          <!-- 繳付方式 -->
          <el-col :xs="24" :sm="12">
            <el-form-item
              :label="$t('message.DataRegistration.Taxi.payment')"
              prop="paymentType"
              :rules="[
                {
                  required: true,
                  message: $t('message.formRuleMessage.notNull'),
                },
              ]"
            >
              <div>
                <el-radio
                  v-for="(item, i) in payMethod"
                  :key="i"
                  v-model="form.paymentType"
                  :label="item.paymentChannel"
                >
                  <img
                    class="mpay_icon"
                    :src="require(`../../../../assets/${item.icon}.png`)"
                    alt=""
                  />
                </el-radio>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </FormBox>
    <div class="payment_notice">
      <div class="pn_title">
        {{ $t("message.DataRegistration.Taxi.notice") }}
      </div>
      <ul class="pn_list">
        <li>
          {{ $t("message.DataRegistration.Taxi.macauMobile")
          }}{{ form.macauMobile }}
        </li>
        <li>
          <span class="pn_email_text">{{
            $t("message.DataRegistration.Taxi.email")
          }}</span>
          <el-form ref="paymentForm" :model="payment" :rules="paymentRules">
            <!-- 電子郵件 -->
            <el-form-item label="" prop="email">
              <el-input
                v-model="payment.email"
                :placeholder="$t('message.DataRegistration.Taxi.email_plh')"
              ></el-input>
            </el-form-item>
            <!-- 電子郵件確認 -->
            <el-form-item label="" prop="confirmEmail">
              <el-input
                v-model="payment.confirmEmail"
                :placeholder="
                  $t('message.DataRegistration.Taxi.email_again_plh')
                "
              ></el-input>
            </el-form-item>
          </el-form>
        </li>
      </ul>
      <div class="email_notice_tips" style="text-align: center">
        {{ $t("message.DataRegistration.Taxi.email_notice_tips") }}
      </div>
    </div>
    <div class="next_btn" v-if="form && form.spCode == '00'">
      <GradientBtn @click="pay()" :loading="submitLoading"
        >{{ $t("message.DataRegistration.Taxi.payment_btn") }} MOP
        {{ form.cheque.totalAmount }}
      </GradientBtn>
    </div>
    <!-- 重複支付彈窗 -->
    <el-dialog
      :title="$t('message.tips')"
      :visible.sync="showRepeatDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="350px"
      :before-close="handleClose"
      top="30vh"
    >
      <div style="font-size: 16px; white-space: pre-line">
        {{ $t("message.ErrorMessage.REPEAT_PAYMENT_ERROR") }} {{ rocallTime }}
        {{ $t("message.ErrorMessage.REPEAT_PAYMENT_ERROR1") }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose">{{ $t('message.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { resourcePath } from "../../../../api/axios";
import i18n from "../../../../../public/lang/index";
import FormBox from "./FormBox";
import GradientBtn from "../../../../components/GradientBtn";
import TaxiPublicAPI from "../../../../api/TaxiPublicAPI";
import ServiceTypeConfigAPI from "@/api/ServiceTypeConfigAPI";

var myTime;
export default {
  props: ["form"],
  components: { FormBox, GradientBtn },
  data() {
    let confirmEmailCheck = (rule, value, callback) => {
      if (this.payment.email && !value) {
        callback(new Error(i18n.t("message.formRuleMessage.taxi_email")));
      } else if (this.payment.email && value !== this.payment.email) {
        callback(
          new Error(i18n.t("message.formRuleMessage.taxi_email_confirm"))
        );
      } else {
        callback();
      }
    };
    return {
      loading: false,
      submitLoading: false,
      resourcePath: resourcePath,
      payment: {},
      paymentRules: {
        email: [
          {
            type: "email",
            message: i18n.t("message.formRuleMessage.email"),
            trigger: ["blur"],
          },
        ],
        confirmEmail: [
          { validator: confirmEmailCheck, trigger: "blur" },
          {
            type: "email",
            message: i18n.t("message.formRuleMessage.email"),
            trigger: ["blur"],
          },
        ],
      },
      showRepeatDialog: false,
      rocallTime: "00:00",
      payMethod: [],
    };
  },
  computed: {
    approved() {
      const form = this.form;
      return form && form.application && form.application.approvedTime
        ? this.$t("message.DataRegistration.Taxi.payment_paid")
        : this.$t("message.DataRegistration.Taxi.no_payment");
    },
  },
  methods: {
    // 子組件校驗，傳到父組件
    validateForm() {
      let flag = null;
      this.$refs["paymentForm"].validate((valid) => {
        console.log(valid);
        if (valid) {
          flag = true;
        } else {
          flag = false;
        }
      });
      return flag;
    },
    // 立即支付
    async pay() {
      try {
        await this.$refs["ruleForm"].validate();
        await this.$refs["paymentForm"].validate();
      } catch (error) {
        return;
      }
      try {
        const serviceType = this.$store.state.serviceType;
        const applicationNo = this.form.applicationNo;
        const channel = this.form.paymentType;
        const email = this.payment.email;
        const url = `${
          this.resourcePath
        }/public/api/v1/application/taxi/start/pay/${serviceType}?applicationNo=${applicationNo}&channel=${channel}${
          email ? `&email=${email}` : ""
        }`;
        this.submitLoading = true;
        await TaxiPublicAPI.frequency(applicationNo);

        this.submitLoading = false;
        if (this.$store.state.isApp) {
          this.$router.push({
            path: "/way",
            query: {
              url: url,
            },
          });
        } else {
          this.submitLoading = true;
          window.location.href = url;
        }
      } catch (err) {
        this.submitLoading = false;
        if (err.code == "REPEAT_PAYMENT_ERROR") {
          this.ComputetTime({
            currentTime: this.$formatDate(
              new Date().toISOString(),
              "yyyy-MM-dd HH:mm:ss"
            ),
            formatCreateTime: err.message,
          });
          this.showRepeatDialog = true;
        } else {
          if (err.code == "PAYMENT_CHECK_FAIL") {
            const errMsg = JSON.parse(err.message);
            this.$message({
              type: "error",
              message:
                errMsg[
                  `failedMsg${
                    this.$i18n.locale == "ZH_TW" || this.$i18n.locale == "ZH_CN"
                      ? "Cn"
                      : "Pt"
                  }`
                ],
            });
          } else {
            this.$error(err);
          }
        }
      }
    },
    // 關閉重複支付提示彈窗
    handleClose() {
      clearTimeout(myTime);
      this.showRepeatDialog = false;
    },
    //支付倒计时
    ComputetTime(data) {
      let st = data.currentTime.replace(/\-/g, "/"), //当前服务器时间
        ct = data.formatCreateTime.replace(/\-/g, "/"); //创建订单时间
      let ts = new Date(st).getTime(),
        tc = new Date(ct).getTime();
      let cm = 5 * 60 * 1000 - (ts - tc);
      this.runBack(cm);
    },
    runBack(cm) {
      if (cm > 0) {
        cm > 60000
          ? (this.rocallTime =
              (new Date(cm).getMinutes() < 10
                ? "0" + new Date(cm).getMinutes()
                : new Date(cm).getMinutes()) +
              ":" +
              (new Date(cm).getSeconds() < 10
                ? "0" + new Date(cm).getSeconds()
                : new Date(cm).getSeconds()))
          : (this.rocallTime =
              "00:" +
              (new Date(cm).getSeconds() < 10
                ? "0" + new Date(cm).getSeconds()
                : new Date(cm).getSeconds()));
        let _msThis = this;
        myTime = setTimeout(function () {
          cm -= 1000;
          _msThis.runBack(cm);
        }, 1000);
      } else {
        this.showRepeatDialog = false;
      }
    },
    // 獲取支付方式
    getPayMethod() {
      const serviceType = this.$store.state.serviceType || "TAXI_ANNUAL";
      this.loading = true;
      ServiceTypeConfigAPI.getPayMethod(serviceType)
        .then((res) => {
          this.loading = false;
          this.payMethod = res.map((ele) => {
            ele.icon = ele.paymentChannel.toLowerCase();
            ele.name = ele.paymentChannel;
            return ele;
          });
          // 只有一個支付方式時，默認選中
          if (res && res.length === 1) {
            this.$set(this.form, "paymentType", res[0].paymentChannel);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
        });
    },
  },
  created() {
    console.log();
    console.log(
      this.$formatDate(new Date().toISOString(), "yyyy-MM-dd HH:mm:ss")
    );
    this.getPayMethod();
  },
};
</script>

<style lang="scss" scoped>
.payment_notice {
  max-width: 700px;
  margin: auto;
  padding: 30px;
  background: #fef9f3;
  border: 1px solid #facd91;
  border-radius: 5px;
}
.pn_title {
  color: #f59a23;
  font-size: 26px;
  margin-bottom: 20px;
}
.pn_list {
  /deep/.el-form {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  /deep/.el-form-item {
    margin-right: 20px;
  }
  /deep/.el-form-item.is-error .el-input__inner {
    box-shadow: 0 0 black;
  }
}
.pn_list li {
  margin-bottom: 12px;
  font-size: 18px;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
}
.pn_list li span {
  display: inline-block;
  min-width: 180px;
}
.pn_list li .el-input {
  flex: 1;
  margin-right: 20px;
}
/deep/.pn_list li .el-input input {
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid #333;
  background-color: transparent;
  text-align: center;
}
/deep/.el-radio {
  display: flex;
  flex-direction: row;
  align-items: center;
}
/deep/.el-radio__label {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.mpay_icon {
  width: auto;
  height: 50px;
  display: block;
  margin-right: 10px;
}
/deep/.el-input__inner {
  &::placeholder {
    color: red;
  }

  &::-webkit-input-placeholder {
    /* WebKit browsers 适配谷歌 */
    color: red;
  }

  &:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 适配火狐 */
    color: red;
  }

  &::-moz-placeholder {
    /* Mozilla Firefox 19+ 适配火狐 */
    color: red;
  }

  &:-ms-input-placeholder {
    /* Internet Explorer 10+  适配ie*/
    color: red;
  }
}
.email_notice_tips {
  text-align: center;
  color: #f59a23;
}

@media screen and (max-width: 767px) {
  .payment_notice {
    margin-left: 15px;
    margin-right: 15px;
  }
  .pn_email_text {
    margin-bottom: 20px;
  }
  /deep/.pn_list .el-form {
    flex-direction: column;
    .el-form-item {
    }
  }
}
</style>
